'use client';
// -------------- 图标 -------------------- //
import ArrowRight from '@/assets/icons/ArrowRight.svg';
// -------------- 组件 -------------------- //
import JumpLink from '@/components/JumpLink';
import JDIProductCardV2 from '@/components/productCard/components/type1';
// -------------- scss -------------------- //
import styles from './style.module.scss';
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/30451';

export default function Module({
  moduleData,
  localInfo,
  floorIndex,
}: {
  moduleData: any;
  localInfo: any;
  floorIndex: number;
}) {
  const { externalData, dataBatch } = moduleData;
  const { t } = useTranslation();
  const jumpParams = dataBatch?.config[0].moreBtnLink;

  const title = dataBatch?.config[0]?.title || t('newArrivals.title');

  // -------------- Product Data -------------------- //
  const getProductData = (product: any, index: number) => {
    return {
      type: '1',
      skuId: product.skuId,
      skuName: product?.skuName,
      skuImg: product?.imageUrl,
      realPrice: product?.realPrice,
      originalPrice: product?.originalPrice,
      currency: localInfo?.currencyCode,
      languageCode: localInfo?.languageCode,
      shouldShowCard: false,
      shouldShowSkuName: true,
      priority: floorIndex < 6 && index < 4,

      // -------------- styles-------------------- //
      containerStyle: {
        flex: 1,
        width: '100%',
        height: '100%',
        minWidth: '120px',
        minHeight: '172px',
      },
      skuImgStyle: {
        width: '120px',
        height: '120px',
      },
      skuNameStyle: {
        marginTop: '8px',
        fontSize: '14px',
        lineHeight: '18px',
      },
      priceStyle: {
        fontSize: '12px',
        marginRight: '0px',
      },
      // { border: "1px solid blue" },
      realPriceJDIPriceParams: {
        symbolStyle: { fontSize: '12px' },
        integerStyle: { fontSize: '16px' },
        decimalPointStyle: { fontSize: '12px' },
        decimalPlaceStyle: { fontSize: '12px' },
        uiType: 1,
        containerStyle: {
          lineHeight: '18px',
          height: '100%',
        },
      },
      originalPriceJDIPriceParams: {
        symbolStyle: '',
        integerStyle: '',
        decimalPointStyle: '',
        decimalPlaceStyle: '',
        uiType: 1,
        containerStyle: {
          lineHeight: '18px',
          height: '100%',
        },
      },
      trackingPointParams: genEventTrackingInfo(product, index),
    };
  };

  const genJsonParam = (product: any, index: number) => {
    const json_param = {
      skuid: product.skuId,
      index: index,
    };
    return json_param;
  };

  const genEventTrackingInfo = (product: any, index: number) => {
    const eventTrackingInfo = {} as { [key: string]: any };
    const json_param = genJsonParam(product, index);
    const expConfig = {
      useClick: false,
      stay_duration: 0,
      repeated: false,
      area_rate: 0.01,
    };
    eventTrackingInfo['productClickPoint'] = () => sendClickTrack.Home_Pro_NewArrivals(json_param);
    eventTrackingInfo['productParam'] = json_param;
    eventTrackingInfo['productExpConfig'] = {
      event_id: EXPOSURE_RECORD.Home_Pro_NewArrivals_Expo,
      config: expConfig,
      json_param: json_param,
    };
    return eventTrackingInfo;
  };
  if (!externalData || !externalData?.data?.list || externalData?.data?.list.length < 3) {
    return null;
  }

  return (
    <div className={styles['uk-h5-new-arrival']}>
      <div className={styles.header}>
        <JumpLink jumpParams={jumpParams}>
          <div className={styles.headerContainer}>
            <div className={styles.headerTitle}>{title}</div>
            <div className={styles.buttonContainer}>
              <div
                className={styles.headerButton}
                onClick={() => sendClickTrack.Home_Pro_NewArrivals_More()}
                exptag={'exp|' + EXPOSURE_RECORD.Home_Pro_NewArrivals_More_Expo}
                data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
              >
                <p>{dataBatch?.config[0]?.jumpButtonName || t('newArrivals.viewMore')}</p>
              </div>
            </div>
          </div>
          <div className={styles.rightIcon}>
            <ArrowRight className={styles.headerIcon} />
          </div>
        </JumpLink>
      </div>
      <div className={styles.cardContainer}>
        {externalData &&
          externalData?.data?.list.map((item: any, index: any) => {
            return (
              <JDIProductCardV2
                key={item.skuId}
                // @ts-ignore
                productData={getProductData(item, index)}
              />
            );
          })}
      </div>
    </div>
  );
}
